<template>
    <div class="background">
        <div v-if="validationTip" class="validationTip">{{ validationTip }}</div>
        <div v-if="showAgreementModal" class="agreementModalMask">
            <div class="agreementModal" @click.stop>
                <div class="agreementModalTitle">服务协议与隐私条款</div>
                <div class="agreementModalClose" @click="closeAgreementModal">×</div>
                <div class="agreementModalContent">
                    我已阅读并同意<span @click="openPDF()" style="color: #1677FF;cursor: pointer;">《吉林一号在线访问产品使用协议》</span>
                </div>
                <div class="agreementModalActions">
                    <div class="agreementModalBtn agreementModalBtnCancel" @click="closeAgreementModal">取消</div>
                    <div class="agreementModalBtn agreementModalBtnConfirm" @click="confirmAgreement">确认</div>
                </div>
            </div>
        </div>
        <div class="right">
            <div class="rightText1">订单详情</div>
            <div class="rightText2">吉林一号网账号 {{ getCookie("userId") }}</div>
            <div class="rightLine1"></div>
            <div class="rightText3">{{ isPremium ? '高级流量' : '基础流量' }}</div>
            <div class="rightText4">
                <span class="rightText4Style1">{{ selectedPackage.name }}</span>
                <span class="rightText4Style1">{{ num }}个</span>
                <span class="rightText4Style2">￥{{ totalPriceText }}</span>
            </div>
            <div class="rightLine1" style="margin-top: 4.1%;"></div>
            <div class="rightText5">
                <span class="rightText5Style1">实付金额</span>
                <span class="rightText5Style2">￥{{ totalPriceText }}</span>
            </div>
            <img src="../../../assets/dataPack/purchaseData/联系商务经理.png" alt="" class="rightIcon1" @click="$router.push('/onlineService/Home')">
            <div class="rightLine2"></div>
            <div class="rightText5" style="height: 32px;margin-top: 4%;">
                <span class="rightText5Style1" style="font-size: 24px;height: 32px;line-height: 32px;">本次应付</span>
                <span class="rightText5Style2"  style="font-size: 24px;height: 32px;line-height: 32px;">￥{{ totalPriceText }}</span>
            </div>
            <div class="rightText6">
                <img src="../../../assets/dataPack/purchaseData/未选中.png" alt="" v-if="!isAgreed" class="rightIcon2" @click="isAgreed=true">
                <img src="../../../assets/dataPack/purchaseData/选中.png" alt="" v-if="isAgreed" class="rightIcon2" @click="isAgreed=false">
                <div class="rightText6Style">我已阅读并同意<span @click="openPDF()" style="color: #1677FF;cursor: pointer;">《吉林一号在线访问产品使用协议》</span></div>
            </div>
            <div class="rightBtn" @click="handleSubmitOrder">提交订单</div>
        </div>
        <div class="left">
            <div class="leftCtn">
                <div class="leftText1">选购产品</div>
                <div class="leftWhite">
                    <img src="../../../assets/dataPack/purchaseData/图标1.png" alt="" class="leftIcon1" v-if="!isPremium">
                    <img src="../../../assets/dataPack/rsManage/高级流量包.png" alt="" class="leftIcon1" v-if="isPremium">
                    <div class="leftText2">{{ isPremium ? '高级流量' : '基础流量' }}</div>
                    <div class="leftText3" @click="togglePackageType">切换套餐</div>
                    <div class="leftLine1"></div>
                    <div class="leftText4">服务单价</div>
                    <div class="leftSel">
                        <div :class="select==1 ? 'leftSel1-s' : 'leftSel1'" @click="select=1">
                            <div class="leftText5">{{ isPremium ? '高级流量包（1万次）' : '基础流量包（10万次）' }}</div>
                            <div class="leftText6">￥{{ isPremium ? 1600 : 500 }}<span style="font-size: 14px;">/个</span></div>
                            <img src="../../../assets/dataPack/purchaseData/对号.png" alt="" class="leftIcon2" v-if="select==1">
                        </div>
                        <div :class="select==2 ? 'leftSel1-s' : 'leftSel1'" @click="select=2">
                            <img src="../../../assets/dataPack/purchaseData/九折.png" alt="" class="leftIcon4">
                            <div class="leftText5">{{ isPremium ? '高级流量包（10万次）' : '基础流量包（100万次）' }}</div>
                            <div class="leftText6">￥{{ isPremium ? 14400 : 4500 }}<span style="font-size: 14px;">/个</span></div>
                            <img src="../../../assets/dataPack/purchaseData/对号.png" alt="" class="leftIcon2" v-if="select==2">
                        </div>
                        <div :class="select==3 ? 'leftSel1-s' : 'leftSel1'" @click="select=3">
                            <img src="../../../assets/dataPack/purchaseData/八折.png" alt="" class="leftIcon4">
                            <div class="leftText5">{{ isPremium ? '高级流量包（100万次）' : '基础流量包（1000万次）' }}</div>
                            <div class="leftText6">￥{{ isPremium ? 128000 : 40000 }}<span style="font-size: 14px;">/个</span></div>
                            <img src="../../../assets/dataPack/purchaseData/对号.png" alt="" class="leftIcon2" v-if="select==3">
                        </div>
                    </div>
                    <div class="leftText7">选择购买流量包数量</div>
                    <div class="leftNum">
                        <img src="../../../assets/dataPack/purchaseData/加减.png" alt="" class="leftIcon3">
                        <input
                            type="text"
                            class="leftNumText"
                            inputmode="numeric"
                            autocomplete="off"
                            v-model="numInput"
                            @input="onQuantityInput"
                            @blur="syncQuantityFromInput"
                        />
                        <div class="leftNumAdd" @click="addNum()"></div>
                        <div class="leftNumReduce" @click="reduceNum()"></div>
                    </div>
                    <div class="leftText8">电子合同</div>
                    <div class="leftText9">默认签署电子合同，如果需要纸质合同可联系商务经理</div>
                    <div :class="contractError ? 'leftContract leftContractError' : 'leftContract'">
                        <span class="leftContractLabel">委托方（甲方）名称</span>
                        <input type="text" placeholder="必填，请输入委托方（甲方）名称" v-model="contractName" :class="contractError ? 'leftContractInput leftContractInputError' : 'leftContractInput'" style="left: 170px; width: 510px;">
                    </div>
                    <div class="leftText8">填写数据用途</div>
                    <div :class="dataFieldError ? 'leftContract leftContractNarrow leftContractError leftContractSelect' : 'leftContract leftContractNarrow leftContractSelect'" style="margin-top: 23px;" @click.stop>
                        <span class="leftContractLabel" style="z-index: 3;">数据应用领域</span>
                        <div :class="dataFieldError ? 'leftSelectPlaceholder leftSelectPlaceholderError' : 'leftSelectPlaceholder'" v-if="!dataUseField" style="left: 130px; width: calc(100% - 146px);">
                            必选，请选择数据应用领域
                        </div>
                        <div :class="dataFieldError ? 'leftSelectInput leftSelectInputError' : 'leftSelectInput'" @click="toggleDataFieldDropdown" style="padding-left: 120px;">
                            <span class="leftSelectValueText">{{ dataUseField }}</span>
                        </div>
                        <div class="leftSelectPanel" v-if="showDataFieldDropdown">
                            <div class="leftSelectOption" v-for="item in dataUseFieldOptions" :key="item" @click="selectDataUseField(item)">
                                {{ item }}
                            </div>
                        </div>
                    </div>
                    <div :class="dataDetailError ? 'leftContract leftContractError' : 'leftContract'" style="margin-top: 23px;">
                        <span class="leftContractLabel">数据具体用途</span>
                        <input type="text" placeholder="必填，请填写数据具体用途" v-model="dataUseDetail" :class="dataDetailError ? 'leftContractInput leftContractInputError' : 'leftContractInput'" style="left: 130px; width: 550px;">
                    </div>
                    <div class="leftText8" style="margin-top: 40px;">订单备注</div>
                    <div class="leftContract" style="margin-top: 23px;">
                        <span class="leftContractLabel">订单备注</span>
                        <input type="text" placeholder="选填，请输入订单备注" v-model="remark" class="leftContractInput" style="left: 100px; width: 580px;">
                    </div>
                    <div class="leftText10">流量生效时间&nbsp;&nbsp; {{ currentDate }} &nbsp;&nbsp;|&nbsp;&nbsp; 流量失效时间&nbsp;&nbsp; {{ oneYearLater }}</div>
                </div>
            </div>
        </div>
        <!-- 认证身份弹窗 -->
        <div class="shadow" v-if="shadowTip">
            <div class="shadowWhite">
                <img src="../../../assets/calendar/日历关闭.png" alt="" class="shadowClose" @click="shadowTip=false">
                <div class="shadowText1">用户身份认证</div>
                <div class="shadowText2">根据国家地理信息安全与保密相关规定，为规范数据使用，保障您的合法权益，购买和使用卫星遥感数据需完成<span style="font-weight: 600;">机构企业用户</span>/<span style="font-weight: 600;">教育科研用户</span>认证。（认证后可享受会员价格）</div>
                <div class="shadowSel" @click="jumpWithPermission('可游客','/store/ApplyGovernmentMember','/rskit')">
                    <img src="../../../assets/dataPack/企业用户.png" alt="" style="position: absolute;width: 100%;height: 100%;">
                </div>
                <div class="shadowSel" @click="jumpWithPermission('可游客','/store/OpenEducationalCertification','/rskit')" style="left: 400px;">
                    <img src="../../../assets/dataPack/教育用户.png" alt="" style="position: absolute;width: 100%;height: 100%;">
                </div>
            </div>
        </div>
        <!-- 机构企业：授权委托书（component 化） -->
        <PurchaseAuthLetterDialog
            :visible.sync="authLetterModalVisible"
            :mode="authLetterModalMode"
            :reject-reason="authorizationLetterRejectReason"
            :user-identity-review-status="userIdentityReviewStatus"
            @success="onAuthLetterSuccess"
            @fail="onAuthLetterFail"
        />
    </div>
</template>
<script>
import {rootUrl} from '@/globalConfig'
import PurchaseAuthLetterDialog from '@/components/PurchaseAuthLetterDialog.vue'
import { checkUserCert } from '@/utils/userCertCheck'
export default {
    name: "purchaseData",
    components: {
        PurchaseAuthLetterDialog,
    },
    data() {
        return {
            select:1,
            num:1,
            numInput: '1',
            isPremium:false,
            contractName:'',
            dataUseField:'',
            dataUseDetail:'',
            remark:'',
            currentDate:'',
            oneYearLater:'',
            isAgreed:false,
            contractError:false,
            dataFieldError:false,
            dataDetailError:false,
            validationTip:'',
            tipTimer:null,
            showAgreementModal:false,
            showDataFieldDropdown:false,
            dataUseFieldOptions:[
                '国土安全',
                '地理测绘',
                '城乡建设与规划',
                '农林生产',
                '智慧城市',
                '生态环保',
                '金融保险',
                '能源',
                '应急及灾害监测',
                '海洋',
                '水利水电',
                '交通运输',
                '地质监测',
                '司法',
                '科教文卫',
            ],
            shadowTip:false,
            authLetterModalVisible: false,
            authLetterModalMode: "not_upload",
            authorizationLetterRejectReason: "",
            // 与 jl1store_front 对齐：0~13 状态码，由 userCertCheck utility 通过 onStatus 回调写入
            // component 内部用此值计算 isEnterprise
            userIdentityReviewStatus: null,
        }
    },
    beforeDestroy() {
        if (this.tipTimer) {
            clearTimeout(this.tipTimer);
            this.tipTimer = null;
        }
        document.removeEventListener('click', this.closeDataFieldDropdown);
    },
    mounted(){
        this.getDay()
        document.addEventListener('click', this.closeDataFieldDropdown);
    },
    created() {
        this.applyPackageFromRoute();
    },
    methods:{
        getKey() {
            return localStorage.getItem("token");
        },
        jumpWithPermission(type,path,fromUrl){
            //path:需要跳转到的路由；fromUrl：如果权限不满足，满足后回跳的路由
            //注意：fromUrl必须为包含本项目router中base的相对地址，如商城个人中心为：/store/UserCenter
            let loginUserId=localStorage.getItem('userId');//是否已登录
            let authentication=localStorage.getItem('authentication');//0:已实名；1：未实名
            if(type=='可游客'){
                if(fromUrl){
                    window.open(rootUrl+path+"?fromUrl="+rootUrl+fromUrl,"_self")
                }
                else {
                    window.open(rootUrl+path,"_self")
                }
            }else if(type=='仅登录'){
                //已登录
                if(loginUserId){
                    if(fromUrl){
                        window.open(rootUrl+path+"?fromUrl="+rootUrl+fromUrl,"_self")
                    }
                    else {
                        window.open(rootUrl+path,"_self")
                    }
                }
                //未登录
                else {
                    if(fromUrl){
                        window.open(rootUrl+'/Login'+"?fromUrl="+rootUrl+fromUrl,"_self")
                    }
                    else {
                        window.open(rootUrl+'/Login',"_self")
                    }
                }
            }else if(type=='仅实名'){
                //已登录
                if(loginUserId){
                    //已实名
                    if(authentication=='0'){
                        if(fromUrl){
                            window.open(rootUrl+path+"?fromUrl="+rootUrl+fromUrl,"_self")
                        }
                        else {
                            window.open(rootUrl+path,"_self")
                        }
                    }
                    //未实名
                    else {
                        window.open(rootUrl+'/Authentication',"_self")
                    }

                }
                //未登录
                else {
                    if(fromUrl){
                        window.open(rootUrl+'/Login'+"?fromUrl="+rootUrl+fromUrl,"_self")
                    }
                    else {
                        window.open(rootUrl+'/Login',"_self")
                    }
                }
            }
        },
        checkAndHandleAuthentication(){
          let loginUserId=localStorage.getItem('userId');//是否已登录
          let authentication=localStorage.getItem('authentication');//0:已实名；1：未实名
          if(!loginUserId){
            this.jumpWithPermission('仅登录','/Login','/rskit/')
          }
          else if(authentication!='0'){
            this.jumpWithPermission('仅实名','/Authentication','/rskit/')
          }
          return true;
        },
        syncQuantityFromInput() {
            const raw = (this.numInput != null ? String(this.numInput) : "").replace(/\D/g, "");
            if (raw === "") {
                this.num = 1;
                this.numInput = "1";
                return;
            }
            let n = parseInt(raw, 10);
            if (isNaN(n) || n < 1) n = 1;
            this.num = n;
            this.numInput = String(n);
        },
        onQuantityInput() {
            this.numInput = (this.numInput != null ? String(this.numInput) : "").replace(/\D/g, "");
            if (this.numInput === "") return;
            const n = parseInt(this.numInput, 10);
            if (!isNaN(n) && n >= 1) {
                this.num = n;
            }
        },
        addNum() {
            this.num++;
            this.numInput = String(this.num);
        },
        reduceNum() {
            if (this.num > 1) {
                this.num--;
                this.numInput = String(this.num);
            }
        },
        getDay(){
            const today = new Date();
            const currentYear = today.getFullYear();
            const currentMonth = String(today.getMonth() + 1).padStart(2, '0');
            const currentDay = String(today.getDate()).padStart(2, '0');
            this.currentDate = `${currentYear}/${currentMonth}/${currentDay}`;
            // 两年后的第二天（用 Date 构造自动处理跨月/跨年）
            const endDate = new Date(today.getFullYear() + 2, today.getMonth(), today.getDate() + 1);
            const endYear = endDate.getFullYear();
            const endMonth = String(endDate.getMonth() + 1).padStart(2, '0');
            const endDay = String(endDate.getDate()).padStart(2, '0');
            this.oneYearLater = `${endYear}/${endMonth}/${endDay}`;
        },
        showValidationTip(message) {
            this.validationTip = message;
            if (this.tipTimer) {
                clearTimeout(this.tipTimer);
            }
            this.tipTimer = setTimeout(() => {
                this.validationTip = '';
                this.tipTimer = null;
            }, 2500);
        },
        async requestUserCenterAndCreateOrder() {
            this.syncQuantityFromInput();
            try {
                const res = await this.axios.get("/loginapi/getUserForUserCenter", {
                    headers: {
                        Authorization: "Bearer " + this.getKey(),
                    },
                });
                if (res.status != 200) {
                    alert("系统错误");
                    return;
                }
                await checkUserCert({
                    axios: this.axios,
                    token: this.getKey(),
                    outerRes: res,
                    onStatus: (code) => { this.userIdentityReviewStatus = code; },
                    onProceed: () => this.createTrafficOrder(),
                    onShowIdentityPicker: () => { this.shadowTip = true; },
                    onNavigate: (path) => this.jumpWithPermission("仅实名", path, "/rskit" + this.$route.fullPath),
                    onOpenAuthLetterDialog: (mode, rejectReason) => {
                        this.authLetterModalMode = mode;
                        this.authorizationLetterRejectReason = rejectReason || '';
                        this.authLetterModalVisible = true;
                    },
                });
            } catch (e) {
                alert("系统错误");
            }
        },
        onAuthLetterSuccess() {
            // 委托书需 1-3 个工作日审核。审核通过前不可创建订单。
            // 用户后续重新点击"提交订单"再次触发 cert check，
            // 若 letter status 已是 proceed（新 API statusCode 6/12），
            // 才进入 createTrafficOrder。这里不做任何操作，component 内部已 topTip 提示。
        },
        onAuthLetterFail() {
            // component 内部已 topTip 提示上传失败，这里无需额外动作
        },
        handleSubmitOrder() {
            this.syncQuantityFromInput();
            this.contractError = false;
            this.dataFieldError = false;
            this.dataDetailError = false;
            if (!this.contractName || !this.contractName.trim()) {
                this.contractError = true;
                this.showValidationTip("请先填写委托方（甲方）名称");
                return;
            }
            if (!this.dataUseField) {
                this.dataFieldError = true;
                this.showValidationTip("请选择数据应用领域");
                return;
            }
            if (!this.dataUseDetail || !this.dataUseDetail.trim()) {
                this.dataDetailError = true;
                this.showValidationTip("请填写数据具体用途");
                return;
            }
            if (!this.isAgreed) {
                this.showAgreementModal = true;
                return;
            }
            this.requestUserCenterAndCreateOrder();
        },
        createTrafficOrder() {
            const orderParams = {
                packageType: this.packageType,
                flowCount: this.selectedPackage.flowCount,
                purchaseNum: this.num,
                unitPrice: this.selectedPackage.price,
                payFinal: this.totalPrice,
                userClientName: this.contractName.trim(),
                applicationField: this.dataUseField,
                dataUsage: this.dataUseDetail.trim(),
                remark: this.remark || "",
            };
            this.axios.post("/tileflowapi/flow/package/createTrafficOrder", orderParams, {
                headers: {
                    Authorization: "Bearer " + this.getKey(),
                },
            }).then((res) => {
                const orderId = res && res.data ? res.data.data : "";
                if (orderId) {
                    this.$router.push({
                        path: "/demandSubmit",
                        query: {
                            id: orderId,
                            orderScene: 'generalTraffic',
                        },
                    });
                    return;
                }
                const msg = (res && res.data && (res.data.msg || res.data.message)) || "创建订单失败";
                this.showValidationTip(msg);
            }).catch((err) => {
                const msg = (err && err.response && err.response.data && (err.response.data.msg || err.response.data.message))
                    || err.message
                    || "创建订单失败";
                this.showValidationTip(msg);
            });
        },
        closeAgreementModal() {
            this.showAgreementModal = false;
        },
        confirmAgreement() {
            this.isAgreed = true;
            this.showAgreementModal = false;
            this.requestUserCenterAndCreateOrder();
        },
        goServiceAgreement() {
            window.open('https://jl1mall.com/ServiceAgreement', '_blank');
        },
        goPrivacyPolicy() {
            window.open('https://jl1mall.com/PrivacyPolicy', '_blank');
        },
        toggleDataFieldDropdown() {
            this.showDataFieldDropdown = !this.showDataFieldDropdown;
        },
        selectDataUseField(value) {
            this.dataUseField = value;
            this.showDataFieldDropdown = false;
        },
        closeDataFieldDropdown() {
            this.showDataFieldDropdown = false;
        },
        togglePackageType(){
            this.isPremium = !this.isPremium;
            this.num = 1; // 切换套餐时重置购买数量
            this.numInput = '1';
            this.select = 1; // 切换套餐时重置为默认第一个档位
        },
        applyPackageFromRoute() {
            const t = this.$route.query.tier;
            if (t === 'premium' || t === '高级') {
                this.isPremium = true;
                this.num = 1;
                this.numInput = '1';
                this.select = 1;
            } else if (t === 'basic') {
                this.isPremium = false;
                this.num = 1;
                this.numInput = '1';
                this.select = 1;
            }
        },
        openPDF(){
            window.open("https://files.jl1mall.com/jl1store/document/吉林一号在线访问产品使用协议.pdf")
        },
    },
    computed: {
        selectedPackage() {
            const basicMap = {
                1: { name: '基础流量包（10万次）', price: 500, flowCount: 100000 },
                2: { name: '基础流量包（100万次）', price: 4500, flowCount: 1000000 },
                3: { name: '基础流量包（1000万次）', price: 40000, flowCount: 10000000 },
            };
            const premiumMap = {
                1: { name: '高级流量包（1万次）', price: 1600, flowCount: 10000 },
                2: { name: '高级流量包（10万次）', price: 14400, flowCount: 100000 },
                3: { name: '高级流量包（100万次）', price: 128000, flowCount: 1000000 },
            };
            const map = this.isPremium ? premiumMap : basicMap;
            return map[this.select] || map[1];
        },
        packageType() {
            return this.isPremium ? 'premium' : 'basic';
        },
        totalPrice() {
            return this.selectedPackage.price * this.num;
        },
        totalPriceText() {
            return this.totalPrice.toFixed(2);
        },
    },
    watch: {
        '$route'() {
            this.applyPackageFromRoute();
        },
        contractName(newVal) {
            if (newVal && newVal.trim()) {
                this.contractError = false;
            }
        },
        dataUseField(newVal) {
            if (newVal) {
                this.dataFieldError = false;
            }
        },
        dataUseDetail(newVal) {
            if (newVal && newVal.trim()) {
                this.dataDetailError = false;
            }
        }
    }
}
</script>
<style scoped>
.background{
    position: relative;
    margin-top: 76px;
    margin-left: 0;
    width: 100vw;
    height: calc(100vh - 76px);
    background-image: url(../../../assets/dataPack/purchaseData/背景.png);
    background-position: center;
    background-size: cover;
}
.validationTip{
    position: fixed;
    left: 50%;
    bottom: 80px;
    transform: translateX(-50%);
    padding: 10px 20px;
    background: rgba(0, 0, 0, 0.75);
    border-radius: 8px;
    color: #FFFFFF;
    font-size: 14px;
    line-height: 22px;
    z-index: 10000;
}
.agreementModalMask{
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    background: rgba(0, 0, 0, 0.45);
    z-index: 10001;
}
.agreementModal{
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    width: 420px;
    background: #FFFFFF;
    border-radius: 8px;
    padding: 20px 20px 16px;
    box-sizing: border-box;
}
.agreementModalTitle{
    font-family: PingFangSC, PingFang SC;
    font-weight: 600;
    font-size: 18px;
    color: rgba(0,0,0,0.85);
    line-height: 26px;
}
.agreementModalClose{
    position: absolute;
    top: 16px;
    right: 16px;
    width: 24px;
    height: 24px;
    line-height: 24px;
    text-align: center;
    font-size: 20px;
    color: rgba(0,0,0,0.45);
    cursor: pointer;
}
.agreementModalContent{
    margin-top: 18px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 14px;
    color: #000000;
    line-height: 22px;
}
.agreementModalLink{
    color: #1677FF;
    cursor: pointer;
}
.agreementModalActions{
    margin-top: 24px;
    display: flex;
    justify-content: flex-end;
    gap: 12px;
}
.agreementModalBtn{
    min-width: 72px;
    height: 32px;
    border-radius: 4px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 500;
    font-size: 14px;
    line-height: 32px;
    text-align: center;
    cursor: pointer;
}
.agreementModalBtnCancel{
    border: 1px solid #D9D9D9;
    color: rgba(0,0,0,0.65);
    background: #FFFFFF;
}
.agreementModalBtnConfirm{
    border: 1px solid #1677FF;
    color: #FFFFFF;
    background: #1677FF;
}
.right{
    position: absolute;
    top: 0;
    right: 0;
    width: 37.5%;
    height: 100%;
    background: #FFFFFF;
    padding-bottom: 20px;
    overflow-y: auto;
    overflow-x: hidden;
}
.rightText1{
    position: relative;
    margin-top: 6.3%;
    margin-left: 8.8%;
    width: auto;
    height: 32px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 500;
    font-size: 24px;
    color: rgba(0,0,0,0.85);
    line-height: 32px;
}
.rightText2{
    position: relative;
    margin-top: 1.6%;
    margin-left: 8.8%;
    width: auto;
    height: 22px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 14px;
    color: rgba(0,0,0,0.65);
    line-height: 22px;
}
.rightLine1{
    position: relative;
    margin-left: 8.8%;
    margin-top: 3.2%;
    width:82.4%;
    height: 1px;
    border-top: 1px solid #D9D9D9;
}
.rightText3{
    position: relative;
    margin-top: 4%;
    margin-left: 8.8%;
    width: auto;
    height: 24px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 500;
    font-size: 16px;
    color: rgba(0,0,0,0.85);
    line-height: 24px;
}
.rightText4{
    position: relative;
    margin-left: 8.8%;
    margin-top:1.2%;
    width:82.4%;
    height: 28px;
    display: flex;
    justify-content: space-between;
    align-items: center;
}
.rightText4Style1{
    height: 28px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 14px;
    color: rgba(0,0,0,0.65);
    line-height: 28px;
}
.rightText4Style2{
    height: 28px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 600;
    font-size: 20px;
    color: #000000;
    line-height: 28px;
}
.rightText5{
    position: relative;
    margin-left: 8.8%;
    margin-top:3.8%;
    width:82.4%;
    height: 28px;
    display: flex;
    justify-content: space-between;
    align-items: center;
}
.rightText5Style1{
    height: 28px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 500;
    font-size: 16px;
    color: rgba(0,0,0,0.85);
    line-height: 28px;
}
.rightText5Style2{
    height: 28px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 600;
    font-size: 20px;
    color: #F5810B;
    line-height: 28px;
}
.rightIcon1{
    position: relative;
    display: block;
    margin-top: 30.3%;
    margin-left: 70.5%;
    cursor: pointer;
}
.rightLine2{
    position: relative;
    margin-top: 0;
    width: 100%;
    height: 1px;
    border-top: 1px dashed #D9D9D9;
}
.rightText6{
    position: relative;
    margin-left: 8.8%;
    margin-top: 2.4%;
    width:82.4%;
    height: 20px;
}
.rightIcon2{
    position: absolute;
    width: 16px;
    top: 2px;
    cursor: pointer;
}
.rightText6Style{
    position: absolute;
    left: 24px;
    width:auto;
    height: 20px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 12px;
    color: rgba(0,0,0,0.65);
    line-height: 20px;
}
.rightBtn{
    position: relative;
    margin-left: 8.8%;
    margin-top:5%;
    width:82.4%;
    height: 56px;
    background: #1890FF;
    border-radius: 24px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 600;
    font-size: 16px;
    color: #FFFFFF;
    line-height: 56px;
    text-align: center;
    cursor: pointer;
}
</style>
<style scoped>
.left{
   position: absolute;
   top: 0;
   left: 0;
     width: 62.5%;
    height: 100%;
}
.leftCtn{
    position: absolute;
    left: calc(50% - 388px);
    width: 776px;
    height: 100%;
}
.leftText1{
    position: absolute;
    top: 6.3%;
    left: 0;
    width:auto;
    height: 32px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 500;
    font-size: 24px;
    color: rgba(0,0,0,0.85);
    line-height: 32px;
}
.leftWhite{
    position: absolute;
    top: 13.5%;
    width: 776px;
    height: 78%;
    background: #FFFFFF;
    box-shadow: 0px 2px 4px 0px rgba(0,0,0,0.5);
    border-radius: 20px;
    overflow-x: hidden;
    overflow-y: auto;
}
.leftIcon1{
    position: relative;
    width: 32px;
    margin-top: 40px;
    margin-left: 40px;
}
.leftText2{
    position: absolute;
    top: 40px;
    left: 88px;
    width: auto;
    height: 32px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 500;
    font-size: 24px;
    color: rgba(0,0,0,0.85);
    line-height: 32px;
}
.leftText3{
    position: absolute;
    top: 44px;
    left: 200px;
    width: 64px;
    height: 24px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 500;
    font-size: 16px;
    color: #1677FF;
    line-height: 24px;
    cursor: pointer;
}
.leftLine1{
    position: relative;
    margin-top: 24px;
    margin-left: 40px;
    width: 696px;
    height: 1px;
    border-top: 1px solid #D9D9D9;
}
.leftText4{
    position: relative;
    margin-top: 24px;
    margin-left: 40px;
    width: auto;
    height: 28px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 500;
    font-size: 20px;
    color: rgba(0,0,0,0.85);
    line-height: 28px;
}
.leftSel{
    position: relative;
    margin-top: 24px;
    margin-left: 40px;
    width: 696px;
    height: 110px;
    display: flex;
    justify-content: space-between;
    align-items: center;
}
.leftSel1{
    position: relative;
    width: 208px;
    height: 110px;
    background: #FFFFFF;
    border-radius: 16px;
    border: 2px solid #D9D9D9;
    cursor: pointer;
}
.leftSel1-s{
    position: relative;
    width: 208px;
    height: 110px;
    background: #FFFFFF;
    border-radius: 16px;
    border: 2px solid #1890FF;
    cursor: pointer;
}
.leftText5{
    position: absolute;
    top: 16px;
    left: 16px;
    width:auto;
    height: 22px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 500;
    font-size: 14px;
    color: rgba(0,0,0,0.85);
    line-height: 22px;
}
.leftText6{
    position: absolute;
    top: 46px;
    left: 16px;
    width: auto;
    height: 32px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 500;
    font-size: 24px;
    color: rgba(0,0,0,0.85);
    line-height: 32px;
}
.leftIcon2{
    position: absolute;
    width: 20px;
    right: 8px;
    bottom: 8px;
}
.leftIcon4{
    position: absolute;
    width: 48px;
    top: 0px;
    right: 1px
}
.leftText7{
    position: relative;
    margin-top: 40px;
    margin-left: 40px;
    width: auto;
    height: 28px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 500;
    font-size: 20px;
    color: rgba(0,0,0,0.85);
    line-height: 28px;
}
.leftNum{
    position: relative;
    margin-top: 16px;
    margin-left: 40px;
    width: 178px;
    height: 40px;

}
.leftIcon3{
    position: absolute;
    width: 178px;
    top: 0;
    left: 0;
}
.leftNumAdd{
    position: absolute;
    right: 0;
    width: 40px;
    height: 40px;
    cursor: pointer;
}
.leftNumReduce{
    position: absolute;
    left: 0;
    width: 40px;
    height: 40px;
    cursor: pointer;
}
.leftNumText{
    position: absolute;
    left: 0;
    top: 0;
    width: 178px;
    height: 40px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 500;
    font-size: 18px;
    color: #000000;
    line-height: 40px;
    text-align: center;
    border: none;
    outline: none;
    background: transparent;
    padding: 0;
    box-sizing: border-box;
}
.leftText8{
    position: relative;
    margin-top: 40px;
    margin-left: 40px;
    width: auto;
    height: 28px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 500;
    font-size: 20px;
    color: rgba(0,0,0,0.85);
    line-height: 28px;
}
.leftText9{
    position: absolute;
    top: 450px;
    left: 136px;
    width:auto;
    height: 22px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 14px;
    color: rgba(0,0,0,0.65);
    line-height: 22px;
}
.leftContract{
   position: relative;
   margin-top: 27px;
   margin-left: 40px;
   width: 696px;
    height: 54px;
    background: #FFFFFF;
    border-radius: 16px;
    border: 1px solid #D9D9D9;
}
.leftContractNarrow{
    width: 417px;
}
.leftContractSelect{
    border-radius: 14px;
    box-shadow: 0 1px 4px rgba(0, 0, 0, 0.06);
    overflow: visible;
}
.leftContractError{
    border: 1px solid #FF0000;
}
.leftContractInput{
    position: absolute;
    left: 16px;
    width: 744px;
    height: 54px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 14px;
    color: rgba(0,0,0,0.65);
    line-height: 54px;
    border: none;
    outline: none;
}
.leftContractLabel{
    position: absolute;
    left: 16px;
    top: 0;
    height: 54px;
    line-height: 54px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 14px;
    color: rgba(0,0,0,0.85);
    white-space: nowrap;
    pointer-events: none;
}
.leftSelectInput{
    position: absolute;
    left: 0;
    width: 100%;
    height: 54px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 14px;
    color: rgba(0,0,0,0.85);
    line-height: 54px;
    border: none;
    outline: none;
    background: transparent;
    cursor: pointer;
    background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='0 0 24 24' fill='none' stroke='%23BFBFBF' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3E%3Cpolyline points='6 9 12 15 18 9'%3E%3C/polyline%3E%3C/svg%3E");
    background-repeat: no-repeat;
    background-position: right 14px center;
    padding: 0 38px 0 16px;
    z-index: 2;
}
.leftSelectInput:hover{
    box-shadow: inset 0 0 0 1px #1677FF;
    border-radius: 14px;
}
.leftSelectValueText{
    display: inline-block;
    width: calc(100% - 40px);
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}
.leftSelectPanel{
    position: absolute;
    top: calc(100% + 8px);
    left: 0;
    width: 100%;
    max-height: 176px;
    overflow-y: auto;
    background: #FFFFFF;
    border: 1px solid #D9D9D9;
    border-radius: 12px;
    box-shadow: 0 8px 20px rgba(0, 0, 0, 0.12);
    z-index: 50;
}
.leftSelectOption{
    height: 44px;
    line-height: 44px;
    padding: 0 16px;
    font-family: PingFangSC, PingFang SC;
    font-size: 14px;
    color: rgba(0,0,0,0.85);
    cursor: pointer;
}
.leftSelectOption:hover{
    background: #F5F8FF;
}
.leftSelectInputError{
    color: rgba(0,0,0,0.85);
}
.leftSelectPlaceholder{
    position: absolute;
    left: 16px;
    width: calc(100% - 32px);
    height: 54px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 14px;
    color: rgba(0,0,0,0.45);
    line-height: 54px;
    pointer-events: none;
    z-index: 1;
}
.leftSelectPlaceholderError{
    color: #FF0000;
}
.leftContractInputError::placeholder{
    color: #FF0000;
}
.leftText10{
    position: relative;
    margin-top: 24px;
    margin-left: 40px;
    margin-bottom: 40px;
    width: auto;
    height: 22px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 14px;
    color: rgba(0,0,0,0.65);
    line-height: 22px;
}
</style>
<style scoped>
.shadow{
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    z-index: 1000001;
    background: rgba(0,0,0,0.4);
}
.shadowWhite{
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%,-50%);
    width: 776px;
    height: 428px;
    background: #FFFFFF;
    border-radius: 16px;
    border: 1px solid #979797;
}
.shadowClose{
    position: absolute;
    top: 28px;
    right: 40px;
    width: 20px;
    z-index: 1;
    font-size: 32px;
    color: #000000;
    cursor: pointer;
}
.shadowText1{
    position: absolute;
    top: 32px;
    width: 100%;
    height: 32px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 500;
    font-size: 24px;
    color: rgba(0,0,0,0.85);
    line-height: 32px;
    text-align: center;
}
.shadowText2{
    position: absolute;
    top: 88px;
    left: 64px;
    width: 648px;
    height: 64px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 16px;
    color: rgba(0,0,0,0.65);
    line-height: 32px;
}
.shadowSel{
    position: absolute;
    top: 192px;
    left: 100px;
    width: 276px;
    height: 157px;
    cursor: pointer;
    background: rgba(0,0,0,0.4);
    box-shadow: 0px 2px 4px 0px rgba(0,0,0,0.5);
    border-radius: 10px;
    overflow: hidden;
}
.shadowSel:hover{
    border: 2px solid #1890FF;
    box-shadow: 0px 2px 4px 0px rgba(0,0,0,0.5);
    border-radius: 10px;
}
</style>
